module.exports = __webpack_public_path__ + "img/no-picture.8bc9be9b.svg";